<style scoped>
 .v-text-field >>> .v-select__selection {
   font-size: 0.8em;
 }
 .v-text-field >>> label {
   font-size: 0.8em;
 }
 .v-text-field >>> button {
   font-size: 0.2em;
 }
 .v-input--switch >>> label {
   font-size: 0.8em;
 }
 .cancel--text-transform {
   text-transform: unset;
 }
</style>
<template>
  <div class="container-00">
    <div class="osc-block-00 osc-border-00 card-00">
      <v-overlay
          absolute
          :value="overlay.show"
          opacity="0.9"
      >
        <v-btn
            depressed
            color="#f6f5ea"
            @click="hideOverlay()"
            class="red--text cancel--text-transform"
        >
          CANCEL "Link"
        </v-btn>
      </v-overlay>
      <div class="card-title-00">
        {{ parameter_group_title }} &nbsp;
        <v-btn x-small icon v-on:click="dump_filter_param()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
      </div>

      <!-- --------------------- -->
      <div class="select-block-00">
        <div class="combobox-block-00 justify-align-center">
          <v-switch
              v-on:click="toggle_filter_link"
              v-model="filter_param_link_state"
              label="Link"
              color="red darken-4"
              hide-details
          ></v-switch>
        </div>
        <div class="combobox-block-00">
          <v-select
              v-model="filter_param.mode"
              v-on:change="onUpdateParam('mode', $event)"
              :background-color="v_select_background_color"
              :items="mode_items"
              item-text="text"
              item-value="id"
              label="MODE"
              menu-props="auto, overflowY"
              outlined
              hide-details
              dense
          ></v-select>
        </div>
      </div>

      <!-- --------------------- -->
      <div class="slider-block-00">
        <div class="slider-00-child-00">
          <div class="slider-label-00 justify-align-center">FREQ</div>
          <div class="slider-ctrl-00">
            <webaudio-slider
                width="20" id="slider10" direction="vert" colors="#fff;#444;#fff" min="36" max="124" :value="filter_param.freq" v-on:change="onUpdateParam('freq', $event.target.value)"
                aconv="const freq=(440 * Math.pow(2,( (Math.floor(88 * x / 127)+36) -69)/12)); freq < 1000 ? String((Math.round(10 * freq) / 10).toFixed(1)) + ' ' : String((Math.round(freq/10) / 100).toFixed(2)) + ' k'"
                conv="const freq=(440 * Math.pow(2,( Math.floor(x -69)/12))); freq < 1000 ? String((Math.round(10 * freq) / 10).toFixed(1)) + ' ' : String((Math.round(freq/10) / 100).toFixed(2)) + ' k'"
                tooltip="FREQ<br/>%sHz"></webaudio-slider>
          </div>
        </div>
      </div>

      <!-- --------------------- -->
      <div class="knob-block-00">
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center">Q</div>
            <!--div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.q" v-on:change="filter_param.q=$event.target.value"></webaudio-knob></div-->
            <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="5" max="127" :value="filter_param.q" v-on:change="onUpdateParam('q', $event.target.value)" conv="(x/10).toFixed(1)" tooltip="Q Factor<br/>%s"></webaudio-knob></div>
          </div>
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center"><div class="label-title-00">BREATH</div><div>MOD</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.breathMod" v-on:change="onUpdateParam('breathMod', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Breath Modulation<br/>%d %"></webaudio-knob></div>
          </div>
        </div>
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center"><div class="justify-align--start">KEY</div><div>FOLLOW</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="52" max="88" :value="filter_param.keyFollow" v-on:change="onUpdateParam('keyFollow', $event.target.value)" conv="x-64" tooltip="KEY FOLLOW<br/>%d"></webaudio-knob></div>
          </div>
          <div class="knob-00-child-00">
            <div class="knob-label-00">CURVE</div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.breathCurve" v-on:change="onUpdateParam('breathCurve', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Breath Curve<br/>%s %"></webaudio-knob></div>
          </div>
        </div>
      </div>

      <!-- --------------------- -->
      <div class="knob-block-00 breath-border-00">
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center"><div class="label-title-00">LFO</div><div>FREQ</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.lfoFreq" v-on:change="onUpdateParam('lfoFreq', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="LFO Rate<br/>%d %"></webaudio-knob></div>
          </div>
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center"><div class="label-title-00"></div><div>BREATH</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.lfoBreath" v-on:change="onUpdateParam('lfoBreath', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="LFO Amount<br/>%s %"></webaudio-knob></div>
          </div>
        </div>
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center">DEPTH</div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.lfoDepth" v-on:change="onUpdateParam('lfoDepth', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="LFO Depth<br/>%d %"></webaudio-knob></div>
          </div>
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center">THRESH</div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.lfoThreshold" v-on:change="onUpdateParam('lfoThreshold', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="LFO Threshold<br/>%d %"></webaudio-knob></div>
          </div>
        </div>
      </div>

      <!-- --------------------- -->
      <div class="knob-block-00">
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center"><div class="label-title-00">SWEEP</div><div>TIME</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.sweepTime" v-on:change="onUpdateParam('sweepTime', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Sweep Time<br/>%d %"></webaudio-knob></div>
          </div>
        </div>
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center">DEPTH</div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="filter_param.sweepDepth" v-on:change="onUpdateParam('sweepDepth', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Sweep Depth<br/>%s %"></webaudio-knob></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
 export default {
   name: 'NOFilter',
   props: ['parameter_group_title', 'label', 'select_items', 'mode_items', 'filterparam', 'filter_link_name', 'secondary'],
   methods: {
     dump_filter_param: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(`[${this.label}:store]`, workingPatch.decoded[`${this.label}Decoded`])
       console.log(`                      filterLink=[${this.$store.getters.getWorkingPatchFilterLink(this.filter_link_name)}]`)
       console.log(`                      filterLink_raw=[${JSON.stringify(workingPatch.decoded.oscFilterLink)}]`)
       console.log(`[${this.label}:local]`, this.$data.filter_param)
     },
     frequencyFromNoteNumber: function( noteNo ) {
       // Special Thenks to @cwilso
       // https://github.com/cwilso/PitchDetect/blob/master/js/pitchdetect.js
       const freq = 440 * Math.pow(2,(noteNo-69)/12);
       if (freq < 1000) {
         return `${String((Math.round(10 * freq) / 10).toFixed(1))}`
       } else {
         return `${String((Math.round(freq/10) / 100).toFixed(2))} k`
       }
     },
     hideOverlay: function() {
       this.$set(this.$data.overlay, 'show', false)
       console.log(this.filter_link_name)
       this.$store.commit('onUpdateWorkingPatchFilterLink', {idx: this.filter_link_name, value: false})
     },
     onUpdateParam: function(key, val) {
       this.$set(this.$data.filter_param, key, val)
       this.$store.commit('onEditOneEditPatch', {arr_idx: [`${this.label}Decoded`, key], value: val})
       //this.$set(this.$data.filter_param, 'mode', this.$data.filter_param.mode)

       /*
       // sync to other panel if param is linked
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const filter_link = this.$store.getters.getWorkingPatchFilterLink(this.filter_link_name)
       let other_label = this.label
       if (this.label.match(/1$/)!=null) {
         other_label = this.label.replace(/1$/, '2')
       } else {
         other_label = this.label.replace(/2$/, '1')
       }
       if (filter_link == true) {
         console.log(`[filter_link=true::${other_label}] filter_link=[${filter_link}] other_label=[${other_label}]`)
         this.$set(this.$data.filter_param, key, val)
         // copy value to other component
         this.$store.commit('onEditOneEditPatch', {arr_idx: [`${other_label}Decoded`, key], value: val})
         this.$router.app.$children[0].$refs.router.applyNOFilterParamToUi(workingPatch_idx, other_label, true)
       }
       */
       // let PatchNumNameCard component to recognise params change
       this.$router.app.$children[0].updateParamIsSyncedApp()
     },
     toggle_filter_link: function() {
       if (this.$store.getters.getWorkingPatchIdx()==null) {
         return
       }
       const filter_link = !this.$store.getters.getWorkingPatchFilterLink(this.filter_link_name)
       // update link state
       console.log(`[NOFilter.vue] ${filter_link}`)
       this.$store.commit('onUpdateWorkingPatchFilterLink', {idx: this.filter_link_name, value: filter_link})
       this.filter_param.link = filter_link
       console.log(`toggle_filter_link: filter_link=[${filter_link}]`)
       /*
       // sync to other panel if param is linked
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       const objectKeys = Object.keys(workingPatch.decoded)
       for (let i=0; i<objectKeys.length; i++) {
         //if (objectKeys[i].toLocaleLowerCase() == this.label) {
         if (objectKeys[i] == this.label) {
           let other_key = ''
           if (objectKeys[i].match(/1$/)!=null) {
             other_key = objectKeys[i].replace(/1$/, '2')
           } else {
             other_key = objectKeys[i].replace(/2$/, '1')
           }
           const tmp_workingPatch = JSON.parse(JSON.stringify(workingPatch))
           tmp_workingPatch.decoded[`${other_key}`] = workingPatch.decoded[`${objectKeys[i]}`]
           tmp_workingPatch.decoded[`${other_key}Decoded`] = workingPatch.decoded[`${objectKeys[i]}Decoded`]
           console.log(`[COPY From] [${objectKeys[i]}] q=`, tmp_workingPatch.decoded[`${objectKeys[i]}Decoded`].q)
           console.log(`[COPY To] [${other_key}] q=`, tmp_workingPatch.decoded[`${other_key}Decoded`].q)
           this.$store.commit('onUpdateEditPatch', {idx: workingPatch_idx, value: tmp_workingPatch})
           this.$router.app.$children[0].$refs.router.applyNOFilterParamToUi(workingPatch_idx, other_key, true)
           break
         }
       }
       */
       this.$router.app.$children[0].updateParamIsSyncedApp()
     }
   },
   created: function() {
     if (this.$store.getters.getWorkingPatchIdx()==null) return
     //this.$data.label = this.in_label
     console.log(`<CREATED> label=[${this.label}]`, this.$data)
     Object.keys(this.filterparam).forEach( key => {
       this.$data.filter_param[key] = this.filterparam[key]
     })
     // initilizer: this will cause bug: DO NOT ENABLE THIS LINE <- ??
     const filter_link_state = this.$store.getters.getWorkingPatchFilterLink(this.filter_link_name)
     this.$store.commit('onUpdateWorkingPatchFilterLink', {idx: this.filter_link_name, value: filter_link_state})
   },
   watch: {
   },
   computed: {
     /*
     filter_param_mode_text: {
       get: function(newVal, oldVal) {
         console.log(`filter_param_mode_text: [${this.mode_items.join(':')}]`, 'new=', newVal, '; old=', oldVal)
         return this.mode_items.indexOf(newVal)
       },
       set: function() {
       }
     },
     */
     filter_param_link_state: {
       get: function() {
         console.log(`[filter_param_link_state:${this.label}] getWorkingPatchFilterLink()=[${this.$store.getters.getWorkingPatchFilterLink(this.filter_link_name)}]`)
         const link_state = this.$store.getters.getWorkingPatchFilterLink(this.filter_link_name)
         if (this.secondary) {
           this.$set(this.$data.overlay, 'show', link_state)
           console.log(link_state)
         }
         this.$router.app.$children[0].updateParamIsSyncedApp()
         return link_state
       },
       set: function(){}
     },
   },
   data: () => ({
     //component_state: 'individual', // {individual, leader, follower}
     v_select_background_color: '#fffef2',
     overlay: {
       show: false
     },
     filter_param: {
       nrpn: 0,
       mode: 0,
       freq: 20,
       q: 25,
       keyFollow: 30,
       breathMod: 35,
       lfoFreq: 40,
       lfoDepth: 45,
       lfoBreath: 50,
       lfoThreshold: 55,
       sweepDepth: 60,
       sweepTime: 65,
       breath_curve: 70,
       //link: false
     }
   })
 }
</script>
